import PropTypes from "prop-types";
import styled from "styled-components";
import { OverlayView } from "@react-google-maps/api";

const PinAnchor = styled.div`
  width: ${(props) => props.$size}px;
  height: ${(props) => props.$size}px;
  transform: translate(-50%, -100%);
`;

const Pin = styled.button`
  width: 100%;
  height: 100%;
  transform: rotate(-45deg);
  border: 3px solid #fff;
  border-radius: 50% 50% 50% 8px;
  background: ${(props) => props.$color};
  box-shadow: 0 2px 7px rgba(0, 0, 0, 0.35);
  cursor: ${(props) => (props.onClick ? "pointer" : "default")};
  padding: 0;
  appearance: none;

  &::after {
    content: "";
    position: absolute;
    width: 30%;
    height: 30%;
    border-radius: 50%;
    background: #fff;
    top: 35%;
    left: 35%;
  }

  &:focus-visible {
    outline: 3px solid #1b74e4;
    outline-offset: 3px;
  }
`;

export default function MapPin({
  position,
  color = "#03660c",
  size = 34,
  label = "Selected location",
  onClick,
}) {
  if (!position) return null;
  return (
    <OverlayView position={position} mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}>
      <PinAnchor $size={size}>
        <Pin
          type="button"
          $color={color}
          aria-label={label}
          onClick={onClick}
          tabIndex={onClick ? 0 : -1}
        />
      </PinAnchor>
    </OverlayView>
  );
}

MapPin.propTypes = {
  position: PropTypes.shape({
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
  }),
  color: PropTypes.string,
  size: PropTypes.number,
  label: PropTypes.string,
  onClick: PropTypes.func,
};
